import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
export default function ChristianClients({ firmData }) {
  const checkIcon = () => {
    return (
      <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 9.22217L4.62 13.2336C4.72528 13.3704 4.86018 13.4815 5.01457 13.5587C5.16896 13.6359 5.33883 13.6772 5.51143 13.6793C5.68125 13.6813 5.84937 13.6454 6.00357 13.5742C6.15778 13.503 6.29418 13.3984 6.40286 13.2679L16.3571 1.22217" stroke="#2F8AB9" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    )
  }

  const stepsData = [
    {
      id: 1,
      title: "Complete the Course",
      icon: "/static/images/cka_landing/Complete Course.png",
      iconAlt: "Complete Course",
      iconWidth: 56,
      iconHeight: 64,
      items: [
        {
          text: "Purchase and enroll in the CKA® Educational Program",
          hasSup: true,
          supText: "®"
        },
        {
          text: "Complete the CKA® Educational Program within six months",
          hasSup: true,
          supText: "®"
        },
        {
          text: "Obtain an overall average 70% passing grade",
          hasSup: false
        },
        {
          text: "Receive a Certificate of Completion",
          hasSup: false,
          isChecked: true
        }
      ]
    },
    {
      id: 2,
      title: "Take the Exam",
      icon: "/static/images/cka_landing/Take Exam.png",
      iconAlt: "Take Exam",
      iconWidth: 56,
      iconHeight: 56,
      items: [
        {
          text: "Pay the exam fee",
          hasSup: false,
          isChecked: true
        },
        {
          text: "Schedule the online CKA® Proctored Exam",
          hasSup: true,
          supText: "®"
        },
        {
          text: "Within 90 days of registering, take the exam, monitored by live proctors",
          hasSup: false
        },
        {
          text: "Achieve a 70% passing grade",
          hasSup: false,
          isChecked: true
        }
      ]
    },
    {
      id: 3,
      title: "Submit the Application",
      icon: "/static/images/cka_landing/Submit Application.png",
      iconAlt: "Submit Application",
      iconWidth: 64,
      iconHeight: 48,
      items: [
        {
          text: "Meet all of the professional requirements",
          hasSup: false
        },
        {
          text: "Complete the application, including three required references",
          hasSup: false
        },
        {
          text: "Pay the application fee",
          hasSup: false
        },
        {
          text: "Maintain active status as a CKA® and meet annual compliance requirements.",
          hasSup: true,
          supText: "®"
        }
      ]
    }
  ]

  const renderStepItem = (item) => {
    return (
      <div className="self-stretch flex justify-start items-start gap-3">
        <div className="w-4 flex-shrink-0 pt-2 pb-0.5 flex flex-col justify-start items-start gap-2.5">
          { checkIcon()}
        </div>
        <div className="flex-1 min-w-0">
          {item.hasSup ? (
            <div className="text-blue-950 text-base lg:text-xl font-normal font-['Instrument-Sans'] leading-7 break-words">
              <span>
                {item.text.split(item.supText)[0]}
              </span>
              <sup>
                {item.supText}
              </sup>
              <span>
                {item.text.split(item.supText)[1]}
              </span>
            </div>
          ) : (
            <div className="text-blue-950 text-base lg:text-xl font-normal font-['Instrument-Sans'] leading-7 break-words">
              {item.text}
            </div>
          )}
        </div>
      </div>
    )
  }
  return (
    <div className='w-full bg-[#f4fafc]'>
    <div className="mx-auto max-w-7xl w-full px-4 py-8 lg:py-32 flex flex-col justify-start items-center gap-10 bg-[#f4fafc] overflow-hidden">
      <div className="w-full relative flex flex-col justify-start items-center gap-20 ">
        {/* Header Section */}
        <div className="self-stretch px-4 lg:px-12 flex flex-col justify-start items-start gap-4">
          <div className="self-stretch inline-flex justify-center items-center">
            <div className="inline-flex flex-col justify-start items-center gap-3">
              <div className="inline-flex justify-start items-center gap-2">
                <div className="text-center justify-start text-[#192f5c] text-base font-semibold font-['Instrument-Sans'] uppercase tracking-wide">
                  Trusted by more than 25 of the nation&apos;s largest financial services firms and still growing
                </div>
              </div>
              <div className="text-center justify-start text-[#192f5c] text-2xl lg:text-4xl font-medium font-['Lora']">
                Christian Clients Are Looking for You!
              </div>
              <div className="text-center justify-start">
                <span className="text-[#192f5c] text-2xl lg:text-4xl font-medium font-['Lora']">Start Your CKA 
                <sup style={{fontSize:'12px'}} className="text-[#192f5c] text-xl lg:text-3xl font-medium font-['Lora']">®</sup>
                </span>
                
                <span className="text-[#192f5c] text-2xl lg:text-4xl font-medium font-['Lora']"> Journey Today.</span>
              </div>
            </div>
          </div>
        </div>

        {/* Three Step Process Cards */}
        <div className="flex flex-col lg:flex-row justify-start items-stretch gap-6 relative">
          {/* Background Arrows */}
          <div className="hidden lg:block absolute -top-48 -right-4 z-0">
            <Image
              src="/static/images/cka_landing/arrows.png"
              alt="top right arrow"
              width={335}
              height={300}
              className="rotate-90 opacity-30"
            />
          </div>
          <div className="hidden lg:block absolute -bottom-60 left-4 z-0">
            <Image
              src="/static/images/cka_landing/arrows.png"
              alt="bottom left arrow"
              width={335}
              height={300}
              className="-rotate-90 opacity-30"
            />
          </div>

          {/* Mapped Step Cards */}
          {stepsData.map((step, index) => (
            <div 
              key={step.id}
              className={`bg-white flex-1 p-4 lg:p-10 bg-background rounded-3xl flex flex-col justify-start items-start gap-12 relative z-10`}
            >
              <div className="self-stretch inline-flex justify-between items-center">
                <div className={`${step.id === 3 ? 'w-16 h-12' : step.id === 2 ? 'w-14 h-14' : 'w-14 h-16'} relative`}>
                  <Image
                    src={step.icon}
                    alt={step.iconAlt}
                    width={step.iconWidth}
                    height={step.iconHeight}
                  />
                </div>
                <div className="w-12 h-12 lg:w-16 lg:h-16 bg-[#fbb35c] rounded-[75px] lg:rounded-[100px]  flex justify-center items-center gap-[3px] lg:gap-1">
                  <div className="text-center text-white justify-start text-Text text-2xl lg:text-3xl font-medium font-['Instrument-Sans']">
                    {step.id}
                  </div>
                </div>
              </div>
              <div className="self-stretch flex flex-col justify-start items-start gap-4 lg:gap-6">
                <div className="w-full flex flex-col justify-start items-start gap-4 lg:gap-6">
                  <div className={`${step.id === 1 ? 'justify-start' : 'self-stretch justify-start'} text-[#192f5c] text-xl lg:text-3xl font-semibold font-['Instrument-Sans'] break-words`}>
                    {step.title}
                  </div>
                  <div className="w-full flex flex-col justify-start items-start gap-4 lg:gap-5">
                    {step.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="w-full">
                        {renderStepItem(item)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Get Certified Button */}
      <Link className='w-full md:w-auto' href={firmData?.get_certified_url || "https://dashboard.kingdomadvisors.com/cka"} target='_blank' rel='noopener noreferrer'>
      <div className="w-full md:w-auto px-8 py-4 bg-[#192F5C] rounded inline-flex justify-center items-center gap-2.5 hover:bg-[#192F5C] transition-colors cursor-pointer">
        <div className="w-6 h-6 relative">
          <Image 
            src="/static/images/cka_landing/yellow arrows.svg" 
            alt="Arrow" 
            width={24} 
            height={24}
          />
        </div>
        <div className="justify-start text-white text-base font-medium font-['Instrument-Sans']">
          Get Certified
        </div>
      </div>
      </Link>
    </div>
  </div>
  )
}
